<template>
  <v-card tile v-if="logs && logs.length">
    <v-card-title class="grey px-4 py-1 d-flex justify-center" style="height: 80px">
      <span
        class="text-h5 font-weight-bold text-uppercase"
        style="opacity: 0.7"
        >logs</span
      >
      <slot name="otherInformation"></slot>
    </v-card-title>
    <v-card-text>
      <v-row no-gutters class="mt-3">
        <v-col cols="12">
          <v-timeline dense>
            <v-timeline-item
              small
              v-for="(log, index) in logs"
              :key="index"
              class="ma-0 pa-0"
            >
              <v-card class="elevation-0 pa-lg-3 mb-4" outlined>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="6" class="pb-2">
                      <span
                        class="font-weight-bold"
                      >
                        {{ log.added_by }}
                      </span>
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <span class="caption font-weight-bold">{{
                        log.created
                      }}</span>
                    </v-col>
                    <v-col
                      class="ma-0 pt-0 pb-0 text-caption text-body-2"
                      cols="12"
                    >
                      <span> {{ log.message }} </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { getOrderStatusColor } from "../../utils/functions.js";
export default {
  props: {
    orderStatus: {
      type: String,
      required: false,
    },
    logs: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      getOrderStatusColor,
    };
  },
};
</script>
